module.exports = __webpack_public_path__ + "img/nounproject_Lecturer_8076.5bf37efe.svg";